import {  createSlice } from '@reduxjs/toolkit';
import {UserModel, UserModelState} from '../models/UserModel'
import AuthService from './AuthService'


const initialState:UserModelState  = {
     usermodel : undefined
}

const userSlice = createSlice({
    name:'user',
    initialState,
    reducers:{
        setUser(state,action:{payload:UserModel}){
            state.usermodel = action.payload;
            console.log("Action payload =>>>", state.usermodel);
            if(action.payload != null){
               AuthService.SetCurrentUser(JSON.stringify(action.payload));
               document.location.reload()
            }
        },
        deleteUser(state, action:{payload:undefined}){
            state.usermodel = undefined;
        },
    }
});

export const {
    setUser, 
    deleteUser
} = userSlice.actions;

export default userSlice.reducer;